<template>
    <div>
        <Navbar v-if="$route.name=='examcorrection'"/>
        <!-- <Breadcrumb v-if="$route.name=='examcorrection'" /> -->
        <div v-if="currentexamid==0">
            <div class="row">
                <div class="col">
                    <div class="card my-3">
                        <div class="card-header">
                            <h5 class="card-title mb-0">Exam Correction</h5>
                        </div>
                        <div class="card-body">
                            <label class="form-label">Correct exams for teacher:</label>
                            <select
                                class="form-select mb-3"
                                v-model="teacher_id"
                                @change="myexams_get"
                            >
                                <option value="">Select Course</option>
                                <option v-for="option in teachers" :key="option.value" :value="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                            
                            <div class="table-responsive">
                                <table class="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th class="d-none">ID</th>
                                            <th>Consultant</th>
                                            <th>Exam</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in myexams" :key="item.id">
                                            <td class="d-none">{{ item.id }}</td>
                                            <td>{{ item.consultant_id }}</td>
                                            <td>{{ item.exam_id }}</td>
                                            <td>
                                                <button 
                                                    class="btn btn-primary btn-sm" 
                                                    @click="currentStudentId=item._consultant_id;currentCourseId = item._course_id;currentexamid = item._exam_id"
                                                >
                                                    Correct
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="currentexamid!==0">
            <ExamCorrectionDetail
                :examId="currentexamid"
                :consultantId="currentStudentId"
                :courseId="currentCourseId"
                :resetCourse="resetCourse"
            />
        </div>
    </div>
</template>
<script>
/* eslint-disable no-console */
import Navbar from './Navbar.vue';
// import Breadcrumb from './Breadcrumb.vue';
import ExamCorrectionDetail from './ExamCorrectionDetail.vue';

const myexamcolumns = [
    { key: 'id', label: 'ID', sortable: false, thClass: 'd-none', tdClass: 'd-none' },
    { key: 'consultant_id', label: 'Consultant', sortable: true },
    { key: 'exam_id', label: 'Exam', sortable: true },
    { key: 'actions', label: 'Actions' }
];

export default {
    name: 'ExamCorrection',
    components: {
        Navbar,
        // Breadcrumb,
        ExamCorrectionDetail,
    },
    data()  {
        return {
            myexams: [],
            currentCourseId: 0,
            currentexamid: 0,
            currentStudentId: 0,
            teachers: [],
            teacher_id: this.$store.state.user_id,
            myexamcolumns,
        }
    },
    created() {
        this.teachers_get();
        this.myexams_get();
        this.currentexamid = 0;
    },  
    methods: {
        resetCourse() {
          this.currentexamid = 0;
          this.currentStudentId = null;
          this.currentCourseId = null;
        },
        async teachers_get() {
            this.$store.dispatch('records_readlist', {
                table_name: 'i_user',
                filter: {},
                sort: 'id',
                order: 'DESC',
                page: 1,
                perPage: 1000
            })
            .then(response => {
                this.teachers = 
                    response.data.result
                    .filter(item => 
                        ([
                            'qbjorn@gmail.com',
                        ].includes(item.email) ||
                        item.email.indexOf('gdq.se') > -1
                        )
                    )
                    .map(item => {
                    return {
                        value: item.id,
                        text: item.email
                    }
                });
            })
            .catch(error => {
                console.log(error);
            });
        },
        async myexams_get() {
            const modulesfilter = {
                module_teacher_id: {
                    value: this.teacher_id,
                    operator: '='
                },
                exam_id: {
                    value: '0',
                    operator: '!='
                },
            }
            this.$store.dispatch('records_readlist', {
                table_name: 'g_elearning_modules',
                filter: modulesfilter,
                sort: 'id',
                order: 'DESC',
                page: 1,
                perPage: 1000
            })
            .then(response => {
                const examids = response.data.result.map(item => item.exam_id);
                const examsfilter = {
                    _exam_id: {
                        value: examids.join(','),
                        operator: 'IN'
                    }, 
                }
                this.$store.dispatch('records_readlist', {
                    table_name: 'g_elearning_consultant_exams',
                    filter: examsfilter,
                    sort: 'id',
                    order: 'DESC',
                    page: 1,
                    perPage: 1000
                })
                .then(response => {
                    this.myexams = response.data.result;
                })
                .catch(error => {
                    console.log(error);
                });
            })
        },
    },
}
</script>
<style>
</style>
